module.exports = __webpack_public_path__ + "img/achievement8.9bb1dee7.png";